import { render, staticRenderFns } from "./producePup.vue?vue&type=template&id=2d364b06&scoped=true&"
import script from "./producePup.vue?vue&type=script&lang=js&"
export * from "./producePup.vue?vue&type=script&lang=js&"
import style0 from "./producePup.vue?vue&type=style&index=0&id=2d364b06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d364b06",
  null
  
)

export default component.exports